import CollectionHandler from 'assets/CollectionHandler'

export const GetProgramTypeString = (programTypes) => {
    const schoolProgramStringArray = programTypes.map((programType) => {
        return CollectionHandler.Translate('programTypeCollection', programType)
    }).sort((a, b) => a.localeCompare(b))

    return schoolProgramStringArray.join(', ')
}
